import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from '../consts/metadata-consts';
import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, getManualResourceIdControl, azureMonitorPrivateLinkScopeResourceId, azureMonitorPrivateLinkScopeResourceIdFormat, azureMonitorPrivateLinkScopeResourceIdErrorMessage } from './shared-control-metadata';


export const azureMonitorPrivateLinkScopePrivateEndpointMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Insights/privatelinkscopes',
    connectionSuffix: 'accessControl',
    resourceIdValidator: azureMonitorPrivateLinkScopeResourceIdFormat,
    groupIdMetadata: {
        azuremonitor: {
            linkedServiceType: 'AzureMonitorPrivateLinkScope',
            groupId: 'azuremonitor',
            iconClass: 'svg-azure-monitor-private-link-scope',
            displayName: stringResources.AzureMonitorPrivateLinkScopes,
            controls: {
                creationControls: getCreationControls(),
                readonlyControls: getReadonlyControls()
            }
        }
    }
};

function getCreationControls(): ControlMetadata[] {
    return [{
        type: 'radio-switch',
        nested: 1,
        label: stringResources.AccountSelectionMethodLabel,
        description: stringResources.AzureMonitorPrivateLinkScope_SelectMethodDescription,
        options: azureResourceSelectMethodOptions,
        isLabelVertical: true,
        defaultValue: '{privateLinkResourceId != null ? "manual" : "azure"}',
        cases: [
            {
                caseValue: 'azure',
                children: [
                    {
                        type: 'azure-monitor-private-link-scopes-select',
                        bind: {
                            name: '',
                            resourceId: 'privateLinkResourceId'
                        },
                        validators: {
                            resourceId: [
                                { type: 'required', errorMessage: '' }
                            ]
                        }
                    }
                ]
            },
            {
                caseValue: 'manual',
                children: [
                    getManualResourceIdControl(
                        format(stringResources.PrivateEndpointResourceIdPlaceholder, azureMonitorPrivateLinkScopeResourceId),
                        azureMonitorPrivateLinkScopeResourceIdFormat,
                        azureMonitorPrivateLinkScopeResourceIdErrorMessage)
                ]
            }
        ]
    }];
}

function getReadonlyControls(): ControlMetadata[] {
    return getReadonlyControl(azureMonitorPrivateLinkScopeResourceIdFormat, azureMonitorPrivateLinkScopeResourceIdErrorMessage);
}
